import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { GET_VENDOR_DOWNLOADS_INFO, GET_VENDOR_DOWNLOADS_INFO_SUCCESS, GET_VENDOR_DOWNLOADS_INFO_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getDownloadsBookingsInfo({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/vendor/downloadsInfoBookings`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...payload?.headers,
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_DOWNLOADS_INFO_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VENDOR_DOWNLOADS_INFO_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_DOWNLOADS_INFO_ERROR, payload: error });
  }
}

export function* watchDownloadsBookingsInfo() {
  yield takeEvery(GET_VENDOR_DOWNLOADS_INFO, getDownloadsBookingsInfo);
}

function* downloadsBookingsInfoSaga() {
  yield all([fork(watchDownloadsBookingsInfo)]);
}

export default downloadsBookingsInfoSaga;
